export class Action<T = {}> {
  type: string;
  payload: T;

  constructor(payload?: T) {
    this.payload = payload;
  }
}
